import gql from 'graphql-tag';
import { locationFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const addLocationMutation = gql`
  mutation AddLocation($input: CreateLocationInput!) {
    addLocation(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminLocationFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${locationFieldsFragment}
`;